module.exports = __webpack_public_path__ + "img/location.e4f8bc67.gif";